import { render, staticRenderFns } from "./WithdrawalDetail.vue?vue&type=template&id=5fe1867b"
import script from "./WithdrawalDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports